import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=ca25b662&scoped=true"
import script from "./Portal.vue?vue&type=script&lang=js"
export * from "./Portal.vue?vue&type=script&lang=js"
import style0 from "./Portal.vue?vue&type=style&index=0&id=ca25b662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca25b662",
  null
  
)

export default component.exports